export interface TeamMember {
  id: string;
  name: string;
  email: string;
  role: string;
  avatar: string;
  lastActive: string;
}

export interface Role {
  name: string;
  description: string;
  permissions: string[];
}

export const teamMembers: TeamMember[] = [
  {
    id: '1',
    name: 'John Smith',
    email: 'john@example.com',
    role: 'Admin',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=32&h=32&fit=crop&crop=face',
    lastActive: '2 hours ago'
  },
  {
    id: '2',
    name: 'Alice Johnson',
    email: 'alice@example.com',
    role: 'Security Engineer',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=32&h=32&fit=crop&crop=face',
    lastActive: '5 minutes ago'
  },
  {
    id: '3',
    name: 'Bob Wilson',
    email: 'bob@example.com',
    role: 'Analyst',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=32&h=32&fit=crop&crop=face',
    lastActive: '1 day ago'
  }
];

export const roles: Role[] = [
  {
    name: 'Admin',
    description: 'Full access to all settings and features',
    permissions: ['Manage team', 'Manage settings', 'View all data', 'Edit all data']
  },
  {
    name: 'Member',
    description: 'Full access to all settings and features',
    permissions: ['Manage team', 'Manage settings', 'View all data', 'Edit all data']
  },
  // {
  //   name: 'Security Engineer',
  //   description: 'Access to security features and findings',
  //   permissions: ['View all data', 'Edit findings', 'Manage scans']
  // },
  // {
  //   name: 'Analyst',
  //   description: 'View-only access to security data',
  //   permissions: ['View all data', 'Create reports']
  // }
];

export const pendingInvites = [
  {
    id: '1',
    email: 'invite1@example.com',
    invitedAt: '2 days ago'
  },
  {
    id: '2',
    email: 'invite2@example.com',
    invitedAt: '2 days ago'
  }
];